/** 工具 */

// 格式化时间，年月日时分秒
export function formatYMDHMS(params){				
	let res=''
	res+=`${params.getFullYear()}-`
	res+=`00${params.getMonth()+1}`.slice(-2).concat('-')
	let date=params.getDate()
	res+=`00${params.getDate()}`.slice(-2).concat(' ')
	res+=`00${params.getHours()}`.slice(-2).concat(':')
	res+=`00${params.getMinutes()}`.slice(-2).concat(':')
	let sec=params.getSeconds()
	res+=`00${params.getSeconds()}`.slice(-2)
	
	return res
}

// 格式化时间，年月日
export function formatYMD(params){				
	let res=''
	res+=`${params.getFullYear()}-`
	res+=`00${params.getMonth()+1}`.slice(-2).concat('-')
	let date=params.getDate()
	res+=`00${params.getDate()}`.slice(-2).concat(' ')
	
	return res
}


// 生成动态路由对象
export function generateRoutes(routesData){
    const routes=[]
    const sdata=JSON.parse(JSON.stringify(routesData))//深拷贝

    // 遍历第一层
    sdata.forEach(item1=>{
        // 遍历第二级
        if(item1.children){
            item1.children.forEach(item2=>{
                const r={}
                r.path=item2.path     
                r.component=() => import(`../views/${item2.component}`)
                r.meta={}
                r.meta.title=item2.name
                r.meta.keepalive=item2.keepalive===1?true:false
                r.meta.icon=item2.icon
                r.meta.url=item2.url
                r.meta.auth=item2.requireAuth===1?true:false
                routes.push(r)
            })
        }
    })

    // 最后添加404界面处理，否则替换一级路由
    routes.push({
        path:':pathMatch(.*)',
        component: () => import('../views/exception/404.vue')
    })

    return routes
}